import React from "react";
import { useChatState } from "../context/ChatStateContext";
import type { ChatConfig } from "@/services/api";

/**
 * XAdkProvider.Header - 可选的头部组件
 *
 * 显示应用信息,用户可以自定义或不使用
 *
 * @example
 * ```tsx
 * <XAdkProvider url="..." token="...">
 *   <XAdkProvider.Header />
 *   <XAdkProvider.Messages />
 * </XAdkProvider>
 * ```
 */
export interface XAdkHeaderProps {
  /** 额外的样式 */
  style?: React.CSSProperties;
  /** 额外的类名 */
  className?: string;
  /** 自定义渲染函数 */
  render?: (appInfo: ChatConfig | null) => React.ReactNode;
}

const Header: React.FC<XAdkHeaderProps> = ({ style, className, render }) => {
  const { appInfo } = useChatState();

  // 如果提供了自定义渲染函数,使用它
  if (render) {
    return <>{render(appInfo)}</>;
  }

  // 默认头部渲染
  if (!appInfo) {
    return null;
  }

  return (
    <div
      className={className}
      style={{
        padding: "16px",
        borderBottom: "1px solid #f0f0f0",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        ...style,
      }}
    >
      {appInfo.icon && (
        <img
          src={appInfo.icon}
          alt="应用图标"
          style={{
            width: 32,
            height: 32,
            borderRadius: "4px",
          }}
        />
      )}
      {appInfo.appName && (
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 500, fontSize: "16px" }}>
            {appInfo.appName}
          </div>
          {appInfo.description && (
            <div style={{ fontSize: "12px", color: "#999", marginTop: "4px" }}>
              {appInfo.description}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

Header.displayName = "XAdkProvider.Header";

export default Header;
